import React from "react";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import "./ViewGrievenceDetails.scss";
import ApiUrl from "services/shared/ApiUrl";
import DownloadIcon from "@mui/icons-material/Download";
import { RouteType } from "constants/RouteType";

const ViewGrievenceDetails = () => {
  const location = useLocation();
  const { grievanceDetails } = location.state || {};
  const navigate = useNavigate();

  // Back To Grievence Redressal List
  const handleBack = () => {
    navigate(RouteType.HOME + RouteType.GRIEVANCE_REDRESSAL);
  };

  const openInTab = (attachmentUrl: string) => {
    if (attachmentUrl) {
      // Open the attachment in a new tab
      window.open(attachmentUrl, "_blank");
    }
  };

  const downloadImage = async (attachmentUrl: string) => {
    if (attachmentUrl) {
      // Download the attachment

      const response = await fetch(attachmentUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = attachmentUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  };

  // Begin The Functions For Checking The Array Fields Has Data Or Not
  const checkInvoiceData = (invoiceData) => {
    return invoiceData?.some(
      (invoiceDetails) =>
        invoiceDetails.invoiceNumber ||
        invoiceDetails.currency ||
        invoiceDetails.invoiceAmount ||
        invoiceDetails.paidDate ||
        invoiceDetails.dueDate ||
        invoiceDetails.invoice
    );
  };

  const checkNetworkData = (networkData) => {
    return networkData?.some(
      (network) =>
        network.networkMembership ||
        network.contactPerson ||
        network.personEmail
    );
  };

  const checkuploadedDocuments = () => {
    return (
      grievanceDetails?.communication?.filter(
        (communication) => communication.trim() !== ""
      ).length > 0 ||
      grievanceDetails?.accountStatement?.filter(
        (account) => account.trim() !== ""
      ).length > 0 ||
      grievanceDetails?.shippingDocument?.filter(
        (shipping) => shipping.trim() !== ""
      ).length > 0 ||
      grievanceDetails?.deliveryReceipt?.filter(
        (delivery) => delivery.trim() !== ""
      ).length > 0
    );
  };

  const checkProtectionClaimData = (details) => {
    return (
      details?.protectionClaimForm ||
      details?.lastDate ||
      details?.formContact ||
      details?.additionalNotes ||
      details?.financialProtectionSystem
    );
  };


  const getFileType = (fileName: string) => {
    const extension = fileName?.split('.').pop()?.toLowerCase();
    if (extension === 'pdf') return 'pdf';
    if (extension === 'xls' || extension === 'xlsx') return 'excel';
    if (['jpg', 'jpeg', 'png'].includes(extension)) return 'image';
    return 'unknown';
  };


  const renderFilePreview = (fileUrl: string) => {
    const fileType = getFileType(fileUrl);
  
    if (fileType === 'pdf') {
      return <img src="/images/pdf.png" alt="PDF" className="file-icon" />;
    } else if (fileType === 'excel') {
      return <img src="/images/xls.png" alt="Excel" className="file-icon" />;
    } else if (fileType === 'image') {
      return <img src={fileUrl} alt="Document" className="grievence-image" />;
    } else {
      return <span>Unsupported file</span>;
    }
  };
  
  

  // End The Functions For Checking The Array Fields Has Data Or Not

  const checkValue = (value) => {
    return value ? value : "No document selected";
  };

  return (
    <>
      <Box sx={{ width: "100%" }} className="container-subheaders">
        <Box sx={{ borderBottom: 1, borderColor: "#ebedf3" }}>
          <div className="content-subheader">
            <h2 className="mr-3">Grievance Redressal Details</h2>
            <button className="btn primary" onClick={handleBack}>
              Back
            </button>
          </div>
        </Box>
        <div className="view-grievence-subcontent">
          <div className="griev-one">
            <h5 className="grievence-headings">Company Details :</h5>
            <div className="container ">
              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="p-2 grievence-headings-content">
                        <strong>Company Name : &nbsp;</strong>  {" "}
                        {checkValue(grievanceDetails?.companyName)}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="p-2 grievence-headings-content">
                        <strong>Company Address : &nbsp;</strong>{" "}
                        {checkValue(grievanceDetails?.address)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="p-2 grievence-headings-content">
                        <strong>Debtor Company : &nbsp;</strong>{" "}
                        {checkValue(grievanceDetails?.debtorCompany)}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="p-2 grievence-headings-content">
                        <strong>Debtor Company Address : &nbsp;</strong> <span> </span>
                        {/* {grievanceDetails?.debtorCompanyAddress} */}
                        {checkValue(grievanceDetails?.debtorCompanyAddress)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="griev-one">
            <h5 className="mt-3 grievence-headings">Invoice Details :</h5>
            <div className="container">
              {grievanceDetails?.invoiceData &&
                grievanceDetails.invoiceData.length > 0 ? (
                grievanceDetails.invoiceData.map((invoiceDetails, index) => (
                  <div className="row" key={index}>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Invoice Number: &nbsp;</strong>{" "}
                        {checkValue(invoiceDetails.invoiceNumber)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Status: &nbsp;</strong> {checkValue(invoiceDetails.status)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Currency: &nbsp;</strong> {checkValue(invoiceDetails.currency)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Invoice Amount: &nbsp;</strong>{" "}
                        {checkValue(invoiceDetails.invoiceAmount)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Paid Date: &nbsp;</strong> {checkValue(invoiceDetails.paidDate)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Due Date: &nbsp;</strong> {checkValue(invoiceDetails.dueDate)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 grievence-headings-content">
                        <strong>Subject: &nbsp;</strong> {checkValue(invoiceDetails.subject)}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="p-2 d-flex align-items-center grievence-headings-content">
                        <strong>Uploaded Invoice: &nbsp;</strong>{" "}
                        {invoiceDetails.invoice ? (
                          <>
                            <img
                              className="grievence-image"
                              src={ApiUrl.fileBaseUrl + invoiceDetails.invoice}
                              onClick={() =>
                                openInTab(
                                  ApiUrl.fileBaseUrl + invoiceDetails.invoice
                                )
                              }
                            />
                             {renderFilePreview(ApiUrl.fileBaseUrl + invoiceDetails.invoice)}
                            <Button
                              onClick={() =>
                                downloadImage(
                                  ApiUrl.fileBaseUrl + invoiceDetails.invoice
                                )
                              }
                              className="grievence-image-download-btn"
                            >
                              <DownloadIcon />
                            </Button>
                          </>
                        ) : (
                          <span>No document selected</span>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-data-div">No document selected</div>
              )}
            </div>

          </div>

          <div className="griev-one">
            {grievanceDetails?.networkData?.length > 0 && (
              <>
                <h5 className="mt-3 grievence-headings">
                  Other Network Membership :
                </h5>
                <div className="container mt-1">
                  {grievanceDetails.networkData.map((network, index) => (
                    <div className="row" key={index}>

                      <div className="p-2 grievence-headings-content">
                        <strong>Other Network Membership: &nbsp;</strong>{" "}
                        {checkValue(network.networkMembership)}
                      </div>


                      <div className="p-2 grievence-headings-content">
                        <strong>Contact Person: &nbsp;</strong>{" "}
                        {checkValue(network.contactPerson)}
                      </div>


                      <div className="p-2 grievence-headings-content">
                        <strong>Contact Person's Email: &nbsp;</strong>{" "}
                        {checkValue(network.personEmail)}
                      </div>

                    </div>
                  ))}
                </div>
              </>
            )}

          </div>


          <div className="container">
            <div className="row">
              <div className="col-md-6 grievv--">
                <div className="griev-one">

                  <h5 className="mt-3 grievence-headings">Uploaded Documents :</h5>
                  <div className="grievence-image-flex">
                    <div className="grievence-image-headings">
                      Uploaded Communication: &nbsp;
                    </div>
                    <div className="d-md-flex">
                      {grievanceDetails?.communication?.filter(
                        (communication) => communication.trim() !== ""
                      ).length > 0 ? (
                        grievanceDetails.communication
                          .filter((communication) => communication.trim() !== "")
                          .map((communication, index) => (
                            <div key={index}>
                              {communication && (
                                <div className="grievence-image-flex">
                                  {/* <img
                                    className="grievence-image"
                                    src={ApiUrl.fileBaseUrl + communication}
                                    onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + communication)
                                    }
                                  /> */}
                                  <div className="cursor-point" onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + communication)
                                    }>{renderFilePreview(ApiUrl.fileBaseUrl + communication)}</div>
                                  <Button
                                    onClick={() =>
                                      downloadImage(ApiUrl.fileBaseUrl + communication)
                                    }
                                    className="grievence-image-download-btn"
                                  >
                                    <DownloadIcon />
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))
                      ) : (
                        <div className="no-data-div">No document selected</div>
                      )}
                    </div>
                  </div>
                  <div className="grievence-image-flex">
                    <div className="grievence-image-headings">
                      Uploaded Statement Of Account: &nbsp;
                    </div>
                    <div className="d-md-flex">
                      {grievanceDetails?.accountStatement?.filter(
                        (account) => account.trim() !== ""
                      ).length > 0 ? (
                        grievanceDetails.accountStatement
                          .filter((account) => account.trim() !== "")
                          .map((account, index) => (
                            <div key={index}>
                              {account && (
                                <div className="grievence-image-flex">
                                  {/* <img
                                    className="grievence-image"
                                    src={ApiUrl.fileBaseUrl + account}
                                    onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + account)
                                    }
                                  /> */}
                                  <div className="cursor-point" onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + account)
                                    }>{renderFilePreview(ApiUrl.fileBaseUrl + account)}</div>
                                  <Button
                                    onClick={() =>
                                      downloadImage(ApiUrl.fileBaseUrl + account)
                                    }
                                    className="grievence-image-download-btn"
                                  >
                                    <DownloadIcon />
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))
                      ) : (
                        <div className="no-data-div">No document selected</div>
                      )}
                    </div>
                  </div>
                  <div className="grievence-image-flex">
                    <div className="grievence-image-headings">
                      Uploaded Shipping Document: &nbsp;
                    </div>
                    <div className="d-md-flex">
                      {grievanceDetails?.shippingDocument?.filter(
                        (shipping) => shipping.trim() !== ""
                      ).length > 0 ? (
                        grievanceDetails.shippingDocument
                          .filter((shipping) => shipping.trim() !== "")
                          .map((shipping, index) => (
                            <div key={index}>
                              {shipping && (
                                <div className="grievence-image-flex">
                                  {/* <img
                                    className="grievence-image"
                                    src={ApiUrl.fileBaseUrl + shipping}
                                    onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + shipping)
                                    }
                                  /> */}
                                  <div className="cursor-point" onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + shipping)
                                    }>{renderFilePreview(ApiUrl.fileBaseUrl + shipping)}</div>
                                  <Button
                                    onClick={() =>
                                      downloadImage(ApiUrl.fileBaseUrl + shipping)
                                    }
                                    className="grievence-image-download-btn"
                                  >
                                    <DownloadIcon />
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))
                      ) : (
                        <div className="no-data-div">No document selected</div>
                      )}
                    </div>
                  </div>

                <div className="grievence-image-flex">
                    <div className="grievence-image-headings">
                      Uploaded Delivery Receipt: &nbsp;
                    </div>
                    <div className="d-md-flex">
                      {grievanceDetails?.deliveryReceipt?.filter(
                        (delivery) => delivery.trim() !== ""
                      ).length > 0 ? (
                        grievanceDetails.deliveryReceipt
                          .filter((delivery) => delivery.trim() !== "")
                          .map((delivery, index) => (
                            <div key={index}>
                              {delivery && (
                                <div className="grievence-image-flex">
                                  {/* <img
                                    className="grievence-image"
                                    src={ApiUrl.fileBaseUrl + delivery}
                                    onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + delivery)
                                    }
                                  /> */}
                                  <div className="cursor-point" onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + delivery)
                                    }>{renderFilePreview(ApiUrl.fileBaseUrl + delivery)}</div>
                                  <Button
                                    onClick={() =>
                                      downloadImage(ApiUrl.fileBaseUrl + delivery)
                                    }
                                    className="grievence-image-download-btn"
                                  >
                                    <DownloadIcon />
                                  </Button>
                                </div>
                              )}
                            </div>
                          ))
                      ) : (
                        <div className="no-data-div">No document selected</div>
                      )}


                    </div>

                  </div>



                </div>

              </div>

              <div className="col-md-6 grievv---">
                <div className="griev-one">
                  <>
                    <h5 className="mt-3 grievence-headings">
                      Uploaded Additional Document :
                    </h5>
                    <div className="grievence-image-flex">
                      <div className="grievence-image-headings">
                        Uploaded Additional Document: &nbsp;
                      </div>
                      <div className="d-md-flex">
                        {grievanceDetails?.additionalRelevantDocuments?.filter(
                          (document) => document.trim() !== ""
                        ).length > 0 ? (
                          grievanceDetails.additionalRelevantDocuments
                            .filter((document) => document.trim() !== "")
                            .map((additionalDocument, index) => (
                              <div key={index}>
                                {additionalDocument && (
                                  <div className="grievence-image-flex">
                                    {/* <img
                                      className="grievence-image"
                                      src={ApiUrl.fileBaseUrl + additionalDocument}
                                      onClick={() =>
                                        openInTab(
                                          ApiUrl.fileBaseUrl + additionalDocument
                                        )
                                      }
                                    /> */}
                                    <div className="cursor-point" onClick={() =>
                                      openInTab(ApiUrl.fileBaseUrl + additionalDocument)
                                    }>{renderFilePreview(ApiUrl.fileBaseUrl + additionalDocument)}</div>
                                    <Button
                                      onClick={() =>
                                        downloadImage(
                                          ApiUrl.fileBaseUrl + additionalDocument
                                        )
                                      }
                                      className="grievence-image-download-btn"
                                    >
                                      <DownloadIcon />
                                    </Button>
                                  </div>
                                )}
                              </div>
                            ))
                        ) : (
                          <div className="no-data-div">No document selected</div>
                        )}
                      </div>
                    </div>
                  </>

                </div>


              </div>
            </div>
          </div>

          <div className="griev-one">
            <h5 className="mt-3 grievence-headings">Protection Claim Form :</h5>

            <>
              <div className="grievence-image-flex">
                <div className="grievence-image-headings">
                  Protection Claim Form: &nbsp;
                </div>
                <div className="d-md-flex">
                  {grievanceDetails?.protectionClaimForm?.length > 0 ? (
                    <div>
                      <img
                        className="grievence-image"
                        src={
                          ApiUrl.fileBaseUrl +
                          grievanceDetails.protectionClaimForm
                        }
                        onClick={() =>
                          openInTab(
                            ApiUrl.fileBaseUrl +
                            grievanceDetails.protectionClaimForm
                          )
                        }
                      />
                    {/* <div>{renderFilePreview(ApiUrl.fileBaseUrl + protectionClaimForm)}</div> */}
                      <Button
                        onClick={() =>
                          downloadImage(
                            ApiUrl.fileBaseUrl +
                            grievanceDetails.protectionClaimForm
                          )
                        }
                        className="grievence-image-download-btn"
                      >
                        <DownloadIcon />
                      </Button>
                    </div>
                  ) : (
                    <div className="no-data-div"> No document selected</div>
                  )}
                </div>
              </div>

              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="p-2 grievence-headings-content">
                      <strong>Last Contact Date: &nbsp;</strong>{" "}
                      {checkValue(grievanceDetails?.lastDate)}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-2 grievence-headings-content">
                      <strong>Last Contact Details: &nbsp;</strong>{" "}
                      {checkValue(grievanceDetails?.formContact)}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-2 grievence-headings-content">
                      <strong>Additional Notes: &nbsp;</strong>{" "}
                      {checkValue(grievanceDetails?.additionalNotes)}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="p-2 grievence-headings-content">
                      <strong>
                        Has the invoice been uploaded to the Financial Protection
                        System? &nbsp;{" "}
                      </strong>
                      {checkValue(grievanceDetails?.financialProtectionSystem)}
                    </div>
                  </div>
                </div>
              </div>
            </>

          </div>
        </div>
      </Box>
    </>
  );
};

export default ViewGrievenceDetails;
